import { useContext, useMemo } from "react"
import { TestTakers, Assessments } from '..'
import { CreateAssessmentsContext } from "../CreateAssessmentsContext"
import { includes } from "lodash"

const useTabs = () => {
    const { selectedTestTakers, selectedAssessmentDefs } = useContext(CreateAssessmentsContext)

    const selectedStudentsCount = useMemo(() => {
        if (!selectedTestTakers)
            return 0

        return Object.keys(selectedTestTakers).filter(
            key => !includes(key, '_') && selectedTestTakers[key] == true
        ).length
    }, [selectedTestTakers])

    const tabs = useMemo(() => [
        {
            label: "בחירת תלמידים",
            Component: TestTakers,
            badge: selectedStudentsCount || null
        },
        {
            label: "בחירת מבדקים",
            Component: Assessments,
            badge: selectedAssessmentDefs?.length || null
        }
    ], [selectedStudentsCount, selectedTestTakers, selectedAssessmentDefs])

    return tabs
}

export default useTabs